// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WZ8i","delete":"styles_delete__3FmLX","update":"styles_update__3OAfw","add":"styles_add__2X-r7"};